import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugAtazanavir} from "./TextDrugAtazanavir"


export default function Atazanavir() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      

     <ButtonsText onClick={handleOpen} name='Atazanavir' size='large' color='common.white' />
    
    <CustomDialog open={open} onClose={handleClose}

        title="Atazanavir - PGx Recommendation"
        content={ <TextDrugAtazanavir />}

        />

</>
)}